import { styled } from 'styled-components';
import { IArticlesRecommended2, defaultParams } from './params';

const Styles = styled.div<{
  $config: IArticlesRecommended2;
}>`
  .articles-recommended {
    padding: 25px 20px 40px;
    margin-bottom: 60px;

    &-list {
      display: grid;
      grid-template-columns: 1fr;
      column-gap: 30px;
      row-gap: 50px;
    }

    &-header {
      color: ${({ $config: styles }) => styles.group_header.color};
      font-family: ${({ $config: styles }) => styles.group_header.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_header.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_header.fontSize};
      line-height: ${({ $config: styles }) => styles.group_header.lineHeight};
      border-bottom: ${({ $config: styles }) => styles.group_header.borderBottom};
      text-align: ${({ $config: styles }) => styles.group_header.textAlign};
      padding-bottom: ${({ $config: styles }) => (styles.group_header.borderBottom === 'none' ? 0 : '12px')};
      margin-bottom: 30px;
    }
  }
`;

export default Styles;
